import { SortOrder } from '../constants'

const DATE_KEY_DEFAULT = '20260901'
const MONTH_KEY_DEFAULT = '202609'

const ALL_ACCOUNTS_LABEL = 'All Accounts'

const CSV_PER_SITE_PREFIX = 'active_sites_per_site'
const CSV_GROUPED_PREFIX = 'active_sites_grouped'

const SITES_CHUNK_SIZE = 3000

const GRAND_TOTAL_LABEL = 'Grand Total'

const STAT_LABELS = {
  PROGRAMS: 'Programs',
  TOTAL_SITES: 'Total Sites',
  AS_ON_DATE: 'As On Date',
  WITHOUT_BATTERY: 'Without Battery',
}

const SORT_KEYS = {
  PROGRAM: 'program',
  ACCOUNT: 'account',
  DATE: 'date',
  COUNT: 'count',
  NO_BATTERY: 'noBattery',
}

const EMPTY_TABLE_TEXT = 'No data available. Enter date_key or month_key and click Fetch & Render.'

const FETCH_ERROR_MESSAGE = 'Failed to fetch site IDs data'

export {
  SortOrder,
  DATE_KEY_DEFAULT,
  MONTH_KEY_DEFAULT,
  ALL_ACCOUNTS_LABEL,
  CSV_PER_SITE_PREFIX,
  CSV_GROUPED_PREFIX,
  SITES_CHUNK_SIZE,
  GRAND_TOTAL_LABEL,
  STAT_LABELS,
  SORT_KEYS,
  EMPTY_TABLE_TEXT,
  FETCH_ERROR_MESSAGE,
}
